// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4540":"css/app.6782","5222":"css/admin-app.6782"}[chunkId] + ".css";
};